<template>
  <div class="login-container">
    <div class="login-form-content">
      <el-form
        :model="ruleForm"
        status-icon
        ref="ruleForm"
        label-position="left"
        label-width="108px"
        class="login-page"
        :rules="rules"
      >
        <div class="title">用户信息设置</div>
        <el-form-item prop="account" label="用户邮件账号">
          <el-input
            type="text"
            v-model="ruleForm.account"
            auto-complete="off"
            placeholder=""
          >
            <template slot="append">{{ emailSuffix }}</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password" label="用户邮件密码">
          <el-input
            type="password"
            v-model="ruleForm.password"
            auto-complete="off"
            show-password
          ></el-input>
        </el-form-item>
        <div style="text-align: center">
          <el-button @click="handleSubmit('ruleForm')" class="mainBtnColor">
            <i class="el-icon-loading" v-if="loading"></i>登录
          </el-button>
          <el-button @click="logOut">退出</el-button>
        </div>
        <!-- <el-form-item>
        <el-checkbox v-model="rememberPassword" @click="doRememberPassword">记住密码</el-checkbox>
        <el-button type="text" @click="forgetpassword">忘记密码</el-button>
      </el-form-item> -->
      </el-form>
    </div>
  </div>
</template>

<script>
// import { requestLogin } from '../api/api';
// import { refreshcode } from '../api/api';
export default {
  name: 'login',
  data() {
    return {
      loading: false,
      ruleForm: {
        account: 'leslee', // leslee
        password: 'vYjyMivHnvxM2Dhk', // vYjyMivHnvxM2Dhk
      },
      emailSuffix: '',
      rules: {
        account: [
          {
            required: true,
            message: '请输入邮件账号',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入邮件密码',
            trigger: 'blur',
          },
        ],
      },
      rememberPassword: localStorage.getItem('userObj') ? true : false,
    }
  },
  methods: {
    handleReset2() {
      this.$refs.ruleForm2.resetFields()
    },

    logOut() {
      sessionStorage.removeItem('emailUser')
    },

    handleSubmit(formName) {
      // if(!this.ruleForm.account) {
      //   this.$message.error('账号不能为空');
      // }else if(!this.ruleForm.password) {
      //   this.$message.error('密码不能为空');
      // }else {

      //}
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.rememberPassword) {
            localStorage.setItem('userObj', JSON.stringify(this.ruleForm))
          } else {
            localStorage.removeItem('userObj')
          }

          if (!this.loading) {
            this.loading = true
            let content = {
              ownerid: '11111',
              name: '专员',
              account: this.ruleForm.account,
              password: this.ruleForm.password,
            }
            this.$api.login(content, {
              onSucess: (res) => {
                if (res.data.errcode === 0) {
                  this.loading = false
                  sessionStorage.setItem('emailUser', JSON.stringify(content))
                  this.$router.push({
                    path: '/homepage',
                  })
                } else {
                  this.loading = false
                  this.$message.error(res.data.errmsg)
                }
              },
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })

      // sessionStorage.setItem('emailUser', JSON.stringify(content));
      // this.$router.push({ path: '/homepage' });
      // this.$refs.ruleForm2.validate((valid) => {
      //   if (valid) {
      //     this.logining = true;
      //     var loginParams = { username: this.ruleForm2.username, password: this.ruleForm2.password, identifycode: this.ruleForm2.identifycode };
      //     requestLogin(loginParams).then(data => {
      //       this.logining = false;
      //       let { msg, code, user } = data;
      //       if (code !== 200) {
      //         this.$message({
      //           message: msg,
      //           type: 'error'
      //         });
      //       } else {
      //         if (user.type === "admin"){
      //             sessionStorage.setItem('user', JSON.stringify(user));
      //             this.$router.push({ path: '/homepage' });
      //         } else if (user.type === "advert") {
      //             sessionStorage.setItem('user', JSON.stringify(user));
      //             this.$router.push({ path: '/table' });
      //         }
      //       }
      //     });
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
    refreshcode() {
      this.uuid = this.getuuid()
      var refreshParams = {
        code: this.ruleForm2.identifycode,
      }
      refreshcode(refreshParams)
        .then((data) => {
          this.imgUrl = serverUrl + '' + this.uuid
        })
        .catch((error) => {
          this.$message({
            message: '服务器请求出错，请重试！',
            type: 'error',
          })
        })
    },
    doRememberPassword() {
      this.rememberPassword = !this.rememberPassword
    },
    forgetpassword() {
      this.$alert('请联系管理员找回密码，管理员电话：131xxxxxxxx', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
      })
    },
  },
  mounted() {
    if (localStorage.getItem('userObj')) {
      this.ruleForm.account = JSON.parse(
        localStorage.getItem('userObj')
      ).account
      this.ruleForm.password = JSON.parse(
        localStorage.getItem('userObj')
      ).password
    }

    // 邮箱的后缀
    this.$api.getEmailSuffix({
      onSucess: (res) => {
        if (res.data.errcode == 0) {
          if (res.data.data) this.emailSuffix = '@' + res.data.data
          else this.emailSuffix = '@'
        } else {
          this.$message.warning(res.data.errmsg)
        }
      },
    })
  },
}
</script>

<style scoped>
/* label.el-checkbox.rememberme {
        margin: 0px 0px 15px;
        text-align: left;
    }
    label.el-button.forget {
        margin: 0;
        padding: 0;
        border: 1px solid transparent;
        outline: none;
    } */
</style>
